import $axios from '@/core/api-config'

class CommentService {
  create (data, projectId) {
    return $axios.post(`/api/comments/${projectId}`, data)
  }

  createWithShare (data, projectId, shareId) {
    return $axios.post(`/api/comments/share/${projectId}/${shareId}`, data)
  }

  delete (id) {
    return $axios.delete(`/api/comments/${id}`)
  }

  update (id, comment) {
    return $axios.put(`/api/comments/${id}`, { body: comment })
  }
}

export const commentService = new CommentService()
